import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import { Button, Box, Typography } from '@mui/material';
import { walkthrough } from '../../../constants/ApiConstants';
import {HTTPMethod, callApi as walkThroughSave } from '../../../services/HttpService/HttpService';
import { checkUrlPath } from '../../Utils/CommonFunctions/CommonFunctions';
import { useDispatch } from 'react-redux';
import { setRelaunchTooltip, setShowTour } from '../../../redux/RelaunchSlice/RelaunchSlice';
import { toggleSubMenus } from '../../../redux/SubMenuToggleSlice/SubMenuToggleSlice';
import Icon from '../../../components/Icon/Icon';
 

export const walkThroughSavePage = (isPlatform = false) => {
  const pageName = isPlatform ? 'Platform' : checkUrlPath();

  if (!pageName) {
    return;
  }

  const requestBody = {
    "page_name": pageName
  }

  walkThroughSave(
    HTTPMethod.Post,
    walkthrough.saveWalkThrough, requestBody
  );
}


export const steps = ({ currentStep, setCurrentStep, steps }) => {
  return (
    <Typography
      color="white"
      sx={{ ml: 2 }}
    >
      Step {currentStep + 1 + " of " + steps.length}
    </Typography>
  )
}


export const nextButton=({
  currentStep,
  stepsLength,
  setIsOpen,
  setCurrentStep,
  steps,
}) => {
  const last = currentStep === stepsLength - 1
  const dispatch = useDispatch();
  return (
    <Button
      color="secondary"
      endIcon={!last ? <Icon icon="chevron-right"/> : undefined}
      sx={{ mr: 2.5 }}
      onClick={() => {
        if (last) {
          setIsOpen(false)
          walkThroughSavePage()
          dispatch(setShowTour({showTour: false}))
          dispatch(toggleSubMenus({ title: 'support' }));
          dispatch(setRelaunchTooltip({openRelaunchTooltip: true}))
        } else {
          if (currentStep === 1) {
            const tableTab = document.querySelector('.routing-container .MuiTab-root:nth-child(2)');
            if (tableTab && !tableTab.classList.contains('Mui-selected')) {
              tableTab.click();
              setTimeout(() => {
                setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s + 1));
              }, 300);
              return;
            }
          }

          setTimeout(() => {
            setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s + 1))
          }, 20);
        }
      }}
    >
      {last ? 'Finish' : 'Next'}
    </Button>
  )
}
